export default __webpack_public_path__ + "static/media/services-header.3927ddcb.jpg";